import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  AmadeusGroupUser as FunctionCode,
  AmadeusSystem as System,
  CaseHasBeenGranted,
  CodePcc,
  DetailedDescriptionOfTheRequest,
  Email,
  EmployeeCode,
  IdUser,
  MEDIUM_ITEM_SIZE,
  PhoneNumber,
  Position,
  Request,
  Users,
  WorkingDepartment,
  AmadeusDutyCode,
  AmadeusOffice,
} from "./_fields";

type EprTemplate = {
  Users: string;
  EmployeeCode: string;
  WorkingDepartment: string;
  Title: string;
  System: string;
  FunctionCode: string;
  CaseHasBeenGranted: string;
  DutyCode: string;
  Office: string;
  Request: string;
  DetailedDescriptionOfTheRequest: string;
  CodePcc: string;
  Email: string;
  PhoneNumber: number;
  IdUser: number;
};

export const changEprTemplate: TemplatesValue<EprTemplate> = {
  fileName: "DanhSachThayDoiAmadeus",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    CodePcc,
    Users,
    EmployeeCode,
    WorkingDepartment,
    {
      ...Position,
      itemSize: MEDIUM_ITEM_SIZE,
    },
    System,
    FunctionCode,
    CaseHasBeenGranted,
    AmadeusDutyCode,
    AmadeusOffice,
    Request,
    DetailedDescriptionOfTheRequest,
    Email,
    {
      ...PhoneNumber,
      header: "SĐT",
    },
    IdUser,
  ],
  fields: [
    "CodePcc",
    "Users",
    "EmployeeCode",
    "WorkingDepartment",
    "Title",
    "System",
    "FunctionCode",
    "CaseHasBeenGranted",
    "DutyCode",
    "Office",
    "Request",
    "DetailedDescriptionOfTheRequest",
    "Email",
    "PhoneNumber",
    "IdUser",
  ],
};
